import {
  ALL_TIME_RANGE_QUERY,
  LAST_12_MONTHS,
  LAST_24_MONTHS,
  LAST_30_DAYS,
  LAST_36_MONTHS,
  LAST_3_MONTHS,
  LAST_6_MONTHS,
  LAST_7_DAYS,
  START_OF_THE_DAY,
} from 'consts/filterOptions'

import type { DateRanges, DateValue } from './types'

export const DEFAULT_TIME_RANGES: DateRanges[] = ['24h', '7d', '30d', '3m', '6m', '12m', '24m', '36m', 'custom']
export const DEFAULT_TIME_RANGES_WITH_ALL_TIME: DateRanges[] = [...DEFAULT_TIME_RANGES, 'all']

export const TIME_RANGE_VALUES: DateValue = {
  '7d': {
    dateAsString: '7d',
    dateAsNumber: 7,
    timeRange: {
      timeValue: 7,
      timeUnit: 'day',
    },
    rangeQuery: { gte: LAST_7_DAYS },
    dateValueAsString: '7',
  },
  '12m': {
    dateAsString: '12m',
    dateAsNumber: 12,
    timeRange: {
      timeValue: 12,
      timeUnit: 'month',
    },
    rangeQuery: { gte: LAST_12_MONTHS },
    dateValueAsString: '12',
  },
  '24h': {
    dateAsString: '24h',
    dateAsNumber: 1,
    timeRange: {
      timeValue: 24,
      timeUnit: 'hour',
    },
    rangeQuery: { gte: START_OF_THE_DAY.valueOf() },
    dateValueAsString: '24h',
  },
  '24m': {
    dateAsString: '24m',
    dateAsNumber: 24,
    timeRange: {
      timeValue: 24,
      timeUnit: 'month',
    },
    rangeQuery: { gte: LAST_24_MONTHS },
    dateValueAsString: '24',
  },
  '30d': {
    dateAsString: '30d',
    dateAsNumber: 30,
    timeRange: {
      timeValue: 30,
      timeUnit: 'day',
    },
    rangeQuery: { gte: LAST_30_DAYS },
    dateValueAsString: '1',
  },
  '36m': {
    dateAsString: '36m',
    dateAsNumber: 36,
    timeRange: {
      timeValue: 36,
      timeUnit: 'month',
    },
    rangeQuery: { gte: LAST_36_MONTHS },
    dateValueAsString: '36',
  },
  all: {
    dateAsString: 'all',
    dateAsNumber: 99,
    timeRange: null,
    rangeQuery: ALL_TIME_RANGE_QUERY,
  },
  '3m': {
    dateAsString: '3m',
    dateAsNumber: 3,
    timeRange: {
      timeValue: 3,
      timeUnit: 'month',
    },
    rangeQuery: { gte: LAST_3_MONTHS },
    dateValueAsString: '3',
  },
  '6m': {
    dateAsString: '6m',
    dateAsNumber: 6,
    timeRange: {
      timeValue: 6,
      timeUnit: 'month',
    },
    rangeQuery: { gte: LAST_6_MONTHS },
    dateValueAsString: '6',
  },
  custom: {
    dateAsString: 'custom',
    dateAsNumber: null,
    timeRange: null,
  },
}

export const oldDateToNewDate = {
  [1]: '24h',
  [7]: '7d',
  [30]: '30d',
  [3]: '3m',
  [6]: '6m',
  [12]: '12m',
  [24]: '24m',
  [36]: '36m',
}
